import React, { useState, useEffect } from 'react';
import { getUser, signOut } from '../../services/auth';
import {
  Menu,
  Content,
  Left,
  Center,
  Right,
  Item,
  Notify,
  BoxNotify,
  Out,
  HeadNotify,
} from './styles';
import NotifyCard from '../../components/NotifyCard';
import api from '../../services/api';
import { showMessage } from '../../hooks/messages';
import { renderError } from '../../hooks/error';
import { useLocation, useHistory } from 'react-router-dom';
import { NotifyProps } from './../../domain/Notify/Notify';

const Header = () => {
  const location = useLocation();
  const history = useHistory();
  const [showNotify, setShowNotify] = useState(false);
  const [notifies, setNotifies] = useState<NotifyProps[]>([]);

  const handleNavigate = (text: string) => {
    history.push(`/${text}`);
  };

  const handleReadMessage = async (notify: NotifyProps) => {
    if (!notify.read) {
      notify.read = true;
      try {
        await api.put(`/notifies/${notify.id}`, notify);
      } catch (err) {
        renderError(err);
      }
    }
    getAllNotifies();
    if (notify.params) {
      history.push(notify.params);
    }
  };

  async function getAllNotifies() {
    const user = getUser();
    try {
      const allNotifies = await api.get(
        `/notifies?_sort=created_at:desc&idReceiver=${user.id}`
      );
      setNotifies(allNotifies.data);
    } catch (err) {
      renderError(err);
      showMessage({
        intent: 'error',
        message: 'não foi possivel obter as notificações',
      });
    }
  }
  useEffect(() => {
    getAllNotifies();
  }, []);

  const handleMarkAllRead = async () => {
    let bufferNotifies: NotifyProps[] = [];
    try {
      for (let notify of notifies) {
        if (!notify.read) {
          let response = await api.put(`/notifies/${notify.id}`, {
            read: true,
          });
          bufferNotifies.push(response.data);
        } else {
          bufferNotifies.push(notify);
        }
      }
      setNotifies(bufferNotifies);
      showMessage({
        intent: 'success',
        message: 'Todas as notificações foram lidas',
      });
    } catch (err) {
      renderError(err);
      showMessage({
        intent: 'error',
        message: 'Erro ao marcar todas as notificações como lidas',
      });
    }
  };

  return (
    <Menu>
      <Content>
        <Left onClick={() => history.push('/home')}>
          <span>A.E. </span> <label> /professores</label>
        </Left>
        <Center>
          <Item
            selected={
              location.pathname.includes('home') ||
              location.pathname.includes('correction') ||
              location.pathname.includes('corrected')
            }
            onClick={() => {
              handleNavigate('home');
            }}
          >
            <svg>
              <path
                d="M4.49992 7.33342H5.33325C5.55427 7.33342 5.76623 7.24562 5.92251 7.08934C6.07879 6.93306 6.16658 6.7211 6.16658 6.50008C6.16658 6.27907 6.07879 6.06711 5.92251 5.91083C5.76623 5.75455 5.55427 5.66675 5.33325 5.66675H4.49992C4.2789 5.66675 4.06694 5.75455 3.91066 5.91083C3.75438 6.06711 3.66658 6.27907 3.66658 6.50008C3.66658 6.7211 3.75438 6.93306 3.91066 7.08934C4.06694 7.24562 4.2789 7.33342 4.49992 7.33342ZM4.49992 9.00008C4.2789 9.00008 4.06694 9.08788 3.91066 9.24416C3.75438 9.40044 3.66658 9.6124 3.66658 9.83342C3.66658 10.0544 3.75438 10.2664 3.91066 10.4227C4.06694 10.579 4.2789 10.6667 4.49992 10.6667H9.49992C9.72093 10.6667 9.93289 10.579 10.0892 10.4227C10.2455 10.2664 10.3333 10.0544 10.3333 9.83342C10.3333 9.6124 10.2455 9.40044 10.0892 9.24416C9.93289 9.08788 9.72093 9.00008 9.49992 9.00008H4.49992ZM13.6666 6.45008C13.6579 6.37353 13.6411 6.29811 13.6166 6.22508V6.15008C13.5765 6.0644 13.5231 5.98564 13.4583 5.91675L8.45825 0.916748C8.38936 0.851928 8.3106 0.798482 8.22492 0.758415C8.20004 0.754881 8.17479 0.754881 8.14992 0.758415C8.06526 0.709866 7.97177 0.678702 7.87492 0.666748H2.83325C2.17021 0.666748 1.53433 0.93014 1.06549 1.39898C0.596644 1.86782 0.333252 2.50371 0.333252 3.16675V14.8334C0.333252 15.4965 0.596644 16.1323 1.06549 16.6012C1.53433 17.07 2.17021 17.3334 2.83325 17.3334H11.1666C11.8296 17.3334 12.4655 17.07 12.9344 16.6012C13.4032 16.1323 13.6666 15.4965 13.6666 14.8334V6.50008C13.6666 6.50008 13.6666 6.50008 13.6666 6.45008ZM8.66658 3.50841L10.8249 5.66675H9.49992C9.2789 5.66675 9.06694 5.57895 8.91066 5.42267C8.75438 5.26639 8.66658 5.05443 8.66658 4.83342V3.50841ZM11.9999 14.8334C11.9999 15.0544 11.9121 15.2664 11.7558 15.4227C11.5996 15.579 11.3876 15.6667 11.1666 15.6667H2.83325C2.61224 15.6667 2.40028 15.579 2.244 15.4227C2.08772 15.2664 1.99992 15.0544 1.99992 14.8334V3.16675C1.99992 2.94573 2.08772 2.73377 2.244 2.57749C2.40028 2.42121 2.61224 2.33341 2.83325 2.33341H6.99992V4.83342C6.99992 5.49646 7.26331 6.13234 7.73215 6.60118C8.20099 7.07002 8.83688 7.33342 9.49992 7.33342H11.9999V14.8334ZM9.49992 12.3334H4.49992C4.2789 12.3334 4.06694 12.4212 3.91066 12.5775C3.75438 12.7338 3.66658 12.9457 3.66658 13.1667C3.66658 13.3878 3.75438 13.5997 3.91066 13.756C4.06694 13.9123 4.2789 14.0001 4.49992 14.0001H9.49992C9.72093 14.0001 9.93289 13.9123 10.0892 13.756C10.2455 13.5997 10.3333 13.3878 10.3333 13.1667C10.3333 12.9457 10.2455 12.7338 10.0892 12.5775C9.93289 12.4212 9.72093 12.3334 9.49992 12.3334Z"
                fill="#0E57B5"
              />
            </svg>
            <label>Redações</label>
          </Item>
          <Item
            selected={location.pathname.includes('profile')}
            onClick={() => {
              handleNavigate('profile');
            }}
          >
            <svg>
              <path
                d="M11.3417 9.23341C11.8692 8.66695 12.1664 7.92406 12.1751 7.15008C12.1751 6.31465 11.8432 5.51343 11.2525 4.9227C10.6617 4.33196 9.86051 4.00008 9.02508 4.00008C8.18965 4.00008 7.38844 4.33196 6.7977 4.9227C6.20696 5.51343 5.87508 6.31465 5.87508 7.15008C5.88378 7.92406 6.18093 8.66695 6.70842 9.23341C5.97396 9.59914 5.34193 10.1417 4.86918 10.8123C4.39642 11.4829 4.09777 12.2604 4.00008 13.0751C3.97577 13.2961 4.04025 13.5177 4.17934 13.6912C4.31843 13.8647 4.52073 13.9758 4.74175 14.0001C4.96276 14.0244 5.18438 13.9599 5.35785 13.8208C5.53132 13.6817 5.64244 13.4794 5.66675 13.2584C5.76619 12.451 6.15745 11.7079 6.76682 11.169C7.37619 10.63 8.1616 10.3326 8.97508 10.3326C9.78857 10.3326 10.574 10.63 11.1833 11.169C11.7927 11.7079 12.184 12.451 12.2834 13.2584C12.3066 13.4721 12.4114 13.6686 12.576 13.8068C12.7406 13.945 12.9523 14.0142 13.1667 14.0001H13.2584C13.4769 13.9749 13.6765 13.8645 13.8139 13.6928C13.9512 13.5211 14.0152 13.3021 13.9917 13.0834C13.9013 12.2731 13.6121 11.4976 13.1498 10.826C12.6875 10.1543 12.0664 9.60725 11.3417 9.23341ZM9.00008 8.63342C8.70671 8.63342 8.41992 8.54642 8.17599 8.38343C7.93205 8.22044 7.74193 7.98877 7.62966 7.71773C7.51739 7.44669 7.48802 7.14844 7.54525 6.8607C7.60248 6.57296 7.74376 6.30865 7.95121 6.10121C8.15865 5.89376 8.42296 5.75249 8.7107 5.69525C8.99844 5.63802 9.29669 5.66739 9.56773 5.77966C9.83877 5.89193 10.0704 6.08205 10.2334 6.32599C10.3964 6.56992 10.4834 6.85671 10.4834 7.15008C10.4834 7.54349 10.3271 7.92078 10.049 8.19896C9.77078 8.47714 9.39349 8.63342 9.00008 8.63342ZM14.8334 0.666748H3.16675C2.50371 0.666748 1.86782 0.93014 1.39898 1.39898C0.93014 1.86782 0.666748 2.50371 0.666748 3.16675V14.8334C0.666748 15.4965 0.93014 16.1323 1.39898 16.6012C1.86782 17.07 2.50371 17.3334 3.16675 17.3334H14.8334C15.4965 17.3334 16.1323 17.07 16.6012 16.6012C17.07 16.1323 17.3334 15.4965 17.3334 14.8334V3.16675C17.3334 2.50371 17.07 1.86782 16.6012 1.39898C16.1323 0.93014 15.4965 0.666748 14.8334 0.666748ZM15.6667 14.8334C15.6667 15.0544 15.579 15.2664 15.4227 15.4227C15.2664 15.579 15.0544 15.6667 14.8334 15.6667H3.16675C2.94573 15.6667 2.73377 15.579 2.57749 15.4227C2.42121 15.2664 2.33341 15.0544 2.33341 14.8334V3.16675C2.33341 2.94573 2.42121 2.73377 2.57749 2.57749C2.73377 2.42121 2.94573 2.33341 3.16675 2.33341H14.8334C15.0544 2.33341 15.2664 2.42121 15.4227 2.57749C15.579 2.73377 15.6667 2.94573 15.6667 3.16675V14.8334Z"
                fill="#0E57B5"
              />
            </svg>
            <label>Perfil</label>
          </Item>
        </Center>
        <Right>
          <Notify
            selected={showNotify}
            onClick={() => {
              setShowNotify(!showNotify);
            }}
            read={!!notifies.filter((notify) => notify.read === false).length}
          >
            <svg width="14" height="18" viewBox="0 0 14 18">
              <path
                d="M12.0002 9.98341V7.33341C11.999 6.15268 11.58 5.01047 10.8173 4.10906C10.0547 3.20765 8.99771 2.6052 7.8335 2.40841V1.50008C7.8335 1.27907 7.7457 1.06711 7.58942 0.910826C7.43314 0.754545 7.22118 0.666748 7.00016 0.666748C6.77915 0.666748 6.56719 0.754545 6.41091 0.910826C6.25463 1.06711 6.16683 1.27907 6.16683 1.50008V2.40841C5.00261 2.6052 3.9456 3.20765 3.18298 4.10906C2.42037 5.01047 2.00136 6.15268 2.00016 7.33341V9.98341C1.51387 10.1553 1.09266 10.4735 0.794278 10.8942C0.495895 11.3149 0.334946 11.8176 0.333496 12.3334V14.0001C0.333496 14.2211 0.421294 14.4331 0.577574 14.5893C0.733854 14.7456 0.945816 14.8334 1.16683 14.8334H3.7835C3.9754 15.5396 4.39433 16.1629 4.97566 16.6074C5.55699 17.0518 6.26841 17.2926 7.00016 17.2926C7.73191 17.2926 8.44334 17.0518 9.02466 16.6074C9.60599 16.1629 10.0249 15.5396 10.2168 14.8334H12.8335C13.0545 14.8334 13.2665 14.7456 13.4228 14.5893C13.579 14.4331 13.6668 14.2211 13.6668 14.0001V12.3334C13.6654 11.8176 13.5044 11.3149 13.206 10.8942C12.9077 10.4735 12.4865 10.1553 12.0002 9.98341ZM3.66683 7.33341C3.66683 6.44936 4.01802 5.60151 4.64314 4.97639C5.26826 4.35127 6.11611 4.00008 7.00016 4.00008C7.88422 4.00008 8.73206 4.35127 9.35718 4.97639C9.98231 5.60151 10.3335 6.44936 10.3335 7.33341V9.83341H3.66683V7.33341ZM7.00016 15.6667C6.70931 15.665 6.42397 15.5872 6.17252 15.441C5.92107 15.2948 5.71225 15.0853 5.56683 14.8334H8.4335C8.28807 15.0853 8.07925 15.2948 7.8278 15.441C7.57635 15.5872 7.29102 15.665 7.00016 15.6667ZM12.0002 13.1667H2.00016V12.3334C2.00016 12.1124 2.08796 11.9004 2.24424 11.7442C2.40052 11.5879 2.61248 11.5001 2.8335 11.5001H11.1668C11.3878 11.5001 11.5998 11.5879 11.7561 11.7442C11.9124 11.9004 12.0002 12.1124 12.0002 12.3334V13.1667Z"
                fill="#6563FF"
              />
            </svg>
            <label>Notificações</label>
            <div />
          </Notify>
          <BoxNotify show={showNotify}>
            <HeadNotify
              onClick={() => {
                handleMarkAllRead();
              }}
            >
              Marcar todas como lidas
            </HeadNotify>
            {notifies.map((notify, index: number) => (
              <NotifyCard
                key={notify.created_at + index}
                notify={notify}
                readMessage={handleReadMessage}
              />
            ))}
          </BoxNotify>
          <Out
            onClick={() => {
              signOut();
              history.push('/');
            }}
          >
            <svg>
              <path d="M0.333252 9.00008C0.333252 9.2211 0.421049 9.43306 0.57733 9.58934C0.73361 9.74562 0.945571 9.83342 1.16659 9.83342H7.49158L5.57492 11.7417C5.49681 11.8192 5.43482 11.9114 5.39251 12.0129C5.3502 12.1145 5.32842 12.2234 5.32842 12.3334C5.32842 12.4434 5.3502 12.5523 5.39251 12.6539C5.43482 12.7554 5.49681 12.8476 5.57492 12.9251C5.65239 13.0032 5.74455 13.0652 5.8461 13.1075C5.94765 13.1498 6.05657 13.1716 6.16658 13.1716C6.27659 13.1716 6.38552 13.1498 6.48707 13.1075C6.58861 13.0652 6.68078 13.0032 6.75825 12.9251L10.0916 9.59175C10.1675 9.5125 10.2269 9.41904 10.2666 9.31675C10.3499 9.11386 10.3499 8.8863 10.2666 8.68342C10.2269 8.58112 10.1675 8.48767 10.0916 8.40841L6.75825 5.07508C6.68055 4.99738 6.58831 4.93575 6.48679 4.8937C6.38527 4.85165 6.27647 4.83001 6.16658 4.83001C6.0567 4.83001 5.9479 4.85165 5.84638 4.8937C5.74486 4.93575 5.65262 4.99738 5.57492 5.07508C5.49722 5.15278 5.43559 5.24502 5.39353 5.34654C5.35148 5.44806 5.32984 5.55687 5.32984 5.66675C5.32984 5.77663 5.35148 5.88544 5.39353 5.98696C5.43559 6.08847 5.49722 6.18072 5.57492 6.25842L7.49158 8.16675H1.16659C0.945571 8.16675 0.73361 8.25455 0.57733 8.41083C0.421049 8.56711 0.333252 8.77907 0.333252 9.00008ZM11.1666 0.666748H2.83325C2.17021 0.666748 1.53433 0.93014 1.06549 1.39898C0.596644 1.86782 0.333252 2.50371 0.333252 3.16675V5.66675C0.333252 5.88776 0.421049 6.09972 0.57733 6.256C0.73361 6.41228 0.945571 6.50008 1.16659 6.50008C1.3876 6.50008 1.59956 6.41228 1.75584 6.256C1.91212 6.09972 1.99992 5.88776 1.99992 5.66675V3.16675C1.99992 2.94573 2.08772 2.73377 2.244 2.57749C2.40028 2.42121 2.61224 2.33341 2.83325 2.33341H11.1666C11.3876 2.33341 11.5996 2.42121 11.7558 2.57749C11.9121 2.73377 11.9999 2.94573 11.9999 3.16675V14.8334C11.9999 15.0544 11.9121 15.2664 11.7558 15.4227C11.5996 15.579 11.3876 15.6667 11.1666 15.6667H2.83325C2.61224 15.6667 2.40028 15.579 2.244 15.4227C2.08772 15.2664 1.99992 15.0544 1.99992 14.8334V12.3334C1.99992 12.1124 1.91212 11.9004 1.75584 11.7442C1.59956 11.5879 1.3876 11.5001 1.16659 11.5001C0.945571 11.5001 0.73361 11.5879 0.57733 11.7442C0.421049 11.9004 0.333252 12.1124 0.333252 12.3334V14.8334C0.333252 15.4965 0.596644 16.1323 1.06549 16.6012C1.53433 17.07 2.17021 17.3334 2.83325 17.3334H11.1666C11.8296 17.3334 12.4655 17.07 12.9344 16.6012C13.4032 16.1323 13.6666 15.4965 13.6666 14.8334V3.16675C13.6666 2.50371 13.4032 1.86782 12.9344 1.39898C12.4655 0.93014 11.8296 0.666748 11.1666 0.666748Z" />
            </svg>
            <label>Sair</label>
          </Out>
        </Right>
      </Content>
    </Menu>
  );
};

export default Header;
